import React, { useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import "moment-timezone";

const EventModalExcerpt = ({ i, event_object }) => {
	const [startDate, setStartDate] = useState(null),
		[startDateNum, setStartDateNum] = useState(null),
		[startTime, setStartTime] = useState(null),
		[eventTitle, setEventTitle] = useState(""),
		[eventSlug, setEventSlug] = useState(""),
		[venueTimezone, setVenueTimezone] = useState(null),
		[venueName, setVenueName] = useState(null);
	// [eventShows, setEventShows] = useState([]),
	// [eventMediaSrc, setEventMediaSrc] = useState(null);

	// const s3Url = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";

	useLayoutEffect(() => {
		let subscribed = true;

		if (subscribed && event_object) {
			Moment.globalTimezone = "America/Los_Angeles";
			Moment.globalLocale = "en-us";
			setEventTitle(event_object.title);
			setEventSlug(event_object.slug);
			setVenueName(event_object.venue_name);
			setVenueTimezone(event_object.venue_timezone);

			const tempDateTime =
				event_object.start_date.split("T")[0] + "T12:00:00.000";
			setStartDate(tempDateTime);
			setStartDateNum(
				event_object.start_date.split("T")[0].split("-")[2],
			);
			let hours =
				event_object.start_time.split(":")[0] +
				":" +
				event_object.start_time.split(":")[1];
			let hoursFormatted = tConvert(hours);
			setStartTime(hoursFormatted);

			// let uniqueShows = event_object.shows.filter(
			// 	(value, index, self) =>
			// 		index === self.findIndex((t) => t.title === value.title),
			// );
			// let sortedUniqueShows = sorter(uniqueShows);
			//
			// setEventShows(sortedUniqueShows);

			// if (Object.keys(event_object.shows).length === 1) {
			// 	setEventMediaSrc(s3Url + event_object.thumbnail);
			// }
		}
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [event_object]);

	// const sorter = (array) => {
	// 	array.sort(function (a, b) {
	// 		var nameA = a.title.replace("The ", "").toLowerCase(),
	// 			nameB = b.title.replace("The ", "").toLowerCase();
	//
	// 		if (nameA < nameB) return -1;
	// 		if (nameA > nameB) return 1;
	// 		return 0;
	// 	});
	// 	return array;
	// };

	const tConvert = (time) => {
		time = time
			.toString()
			.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

		if (time.length > 1) {
			time = time.slice(1);
			time[5] = +time[0] < 12 ? " AM" : " PM";
			time[0] = +time[0] % 12 || 12;
		}
		return time.join("");
	};

	return (
		<a
			key={i}
			className={"events-grid-item events-grid-item-single-title"}
			href={"/events/" + eventSlug}
			onClick={() => {
				window.localStorage.setItem("showEventListModal", "false");
			}}
		>
			<div
				className={
					"events-grid-item-header d-flex flex-column ms-auto align-items-center justify-content-between"
				}
			>
				<div className={"events-grid-item-header-month nf-sans-cond"}>
					<Moment format="MMM">{startDate}</Moment>
				</div>
				<div
					className={"events-grid-item-header-daynumber nf-sans-cond"}
				>
					{startDateNum}
				</div>
				<div className={"events-grid-item-header-dayname nf-sans-cond"}>
					<Moment format="dddd">{startDate}</Moment>
				</div>
			</div>
			<div
				className={"events-grid-item-body"}
				style={{
					minHeight: "auto",
				}}
			>
				<div className={"events-grid-item-title nf-sans-cond"}>
					{eventTitle}
				</div>

				<div className={"events-grid-item-time-venue nf-sans-cond"}>
					{startTime} {venueTimezone} @ {venueName}
				</div>
			</div>
		</a>
	);
};

export default EventModalExcerpt;
